import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	accordionHeader: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase200,
		fontStyle: "normal",
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase200,
		textAlign: "center",
		color: tokens.colorNeutralForeground3,
	},
	accordionContainer: {
		overflowY: "auto",
	},
	accordionPanel: {
		margin: "0px",
	},
	accordionCount: {
		fontWeight: tokens.fontWeightBold,
		fontSize: tokens.fontSizeBase200,
		paddingLeft: "8px",
	},
});
